import { ListItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledNavListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'isActive' && prop !== 'button',
})(({ theme, isActive }) => ({
  borderRadius: 10,
  margin: '0 12px 2px',
  padding: '10px 14px',
  gap: 11,
  backgroundColor: isActive ? theme.portal.accentSoft : 'transparent',
  color: isActive ? theme.portal.accent : theme.portal.textMuted,
  '&:hover': {
    backgroundColor: isActive ? theme.portal.accentSoft : theme.portal.surfaceMuted,
  },
  '& .MuiListItemIcon-root': {
    color: isActive ? theme.portal.accent : theme.portal.textMuted,
    minWidth: 28,
    '& svg': {
      fontSize: 17,
    },
  },
  '& .MuiListItemText-primary': {
    fontSize: 14,
    fontWeight: isActive ? 700 : 600,
    color: isActive ? theme.portal.accent : theme.portal.textMuted,
  },
}));

export default StyledNavListItem;
